
// This file is updated to communicate with your local backend.

// The App component still passes this, so the function signature accepts it,
// but it is not used in the logic for the local backend.
type ModelType = 'bagdaunov' | 'transformer';

export async function translateAndGenerateHeatmap(
  englishText: string,
  modelType: ModelType
): Promise<{ translation: string; imageUrl: string }> {
  const API_BASE_URL = process.env.REACT_APP_TRANSLATOR_BACKEND;
  if (!API_BASE_URL) {
    throw new Error("API base URL is not defined in environment variables.");
  }

  try {
    // 1. POST to the main endpoint to get translation and image ID
    const response = await fetch(API_BASE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model_type: modelType,
        en_text: englishText,
      }),
    });

    if (!response.ok) {
      throw new Error(`Backend error! Status: ${response.status}`);
    }

    const data = await response.json();

    const translation = data.translation;
    const imageId = data.attention_img;

    if (!translation || !imageId) {
      throw new Error("Invalid response format from the backend.");
    }

    // 2. Construct the full image URL using the received ID
    const imageUrl = `${API_BASE_URL}/image?image_id=${imageId}`;

    return { translation, imageUrl };
  } catch (error) {
    console.error("Error communicating with the local backend:", error);
    throw new Error("Failed to connect to the local translation server.");
  }
}
